/**
 * QuoteCart — localStorage-based cart for quote mode.
 * Completely bypasses Shopify's /cart/add API.
 */
const QuoteCart = (function () {
  const STORAGE_KEY = 'quote_cart_items';

  function getItems() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function saveItems(items) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  }

  function addItem(item) {
    const items = getItems();
    const existing = items.find(function (i) {
      return i.variantId === item.variantId;
    });
    if (existing) {
      return getItems();
    }
    items.push({
      variantId: item.variantId,
      productTitle: item.productTitle || '',
      variantTitle: item.variantTitle || '',
      url: item.url || '',
      image: item.image || '',
      quantity: item.quantity || 1,
      price: item.price || 0,
      handle: item.handle || '',
    });
    saveItems(items);
    updateBubble();
    return getItems();
  }

  function removeItem(variantId) {
    const items = getItems().filter(function (i) {
      return i.variantId !== variantId;
    });
    saveItems(items);
    updateBubble();
    return items;
  }

  function updateQuantity(variantId, quantity) {
    const items = getItems();
    if (quantity <= 0) return removeItem(variantId);
    const item = items.find(function (i) {
      return i.variantId === variantId;
    });
    if (item) {
      item.quantity = quantity;
      saveItems(items);
    }
    updateBubble();
    return getItems();
  }

  function getItemCount() {
    return getItems().reduce(function (sum, i) {
      return sum + i.quantity;
    }, 0);
  }

  function clear() {
    localStorage.removeItem(STORAGE_KEY);
    updateBubble();
  }

  function updateBubble() {
    const count = getItemCount();
    document.querySelectorAll('.cart-count-bubble').forEach(function (bubble) {
      const countSpan = bubble.querySelector('[aria-hidden="true"]');
      if (countSpan) countSpan.textContent = count < 100 ? count : '99+';
      bubble.classList.toggle('cart-count-bubble--empty', count === 0);
    });
    // Toggle is-empty on cart drawer
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
      cartDrawer.classList.toggle('is-empty', count === 0);
    }
  }

  function isInCart(variantId) {
    return getItems().some(function (i) {
      return i.variantId === String(variantId);
    });
  }

  function updateCardButtons() {
    document.querySelectorAll('[data-quote-add]').forEach(function (btn) {
      var vid = btn.getAttribute('data-variant-id');
      var inCart = isInCart(vid);
      btn.classList.toggle('is-active', inCart);
      btn.setAttribute('aria-pressed', inCart ? 'true' : 'false');
    });
  }

  function initCardButtons() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-quote-add]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();

      var vid = btn.getAttribute('data-variant-id');
      if (isInCart(vid)) {
        removeItem(vid);
      } else {
        addItem({
          variantId: vid,
          productTitle: btn.getAttribute('data-product-title') || '',
          variantTitle: btn.getAttribute('data-variant-title') || '',
          url: btn.getAttribute('data-url') || '',
          image: btn.getAttribute('data-image') || '',
          quantity: 1,
          price: parseInt(btn.getAttribute('data-price')) || 0,
          handle: btn.getAttribute('data-handle') || '',
        });

        var cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer) {
          cartDrawer.renderQuoteContents();
          cartDrawer.open();
        }
      }
      updateCardButtons();
    });

    updateCardButtons();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCardButtons);
  } else {
    initCardButtons();
  }

  return {
    getItems: getItems,
    addItem: addItem,
    removeItem: removeItem,
    updateQuantity: updateQuantity,
    getItemCount: getItemCount,
    clear: clear,
    updateBubble: updateBubble,
    isInCart: isInCart,
    updateCardButtons: updateCardButtons,
  };
})();
